let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e9Cwk")).then(() => parcelRequire('8INP5'));